import { useState, useEffect } from 'react';
import { InputMask } from '@react-input/mask';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

function FormRegister() {
    const navigate = useNavigate();
    
    const [states, setStates] = useState([]);
    const [lojasSelect, setLojasSelect] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [userData, setUserData] = useState({
        nome: '',
        cpf: '',
        email: '',
        password: '',
        cnpj: '',
        razao: '',
        endereco: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        nascimento: '',
        rg: '',
        fone: '',
        password_confirmation: '',
        estabelecimento_id: '',
    });

    const [userErrorData, setUserErrorData] = useState({
        nome: [],
        cpf: [],
        email: [],
        password: [],
        cnpj: [],
        razao: [],
        endereco: [],
        bairro: [],
        cep: [],
        cidade: [],
        estado: [],
        nascimento: [],
        rg: [],
        fone: [],
        password_confirmation: [],
        estabelecimento_id: [],
    });

    const handleSelectChange = (name, selectedOption) => {
        setUserData(prevData => ({
            ...prevData,
            [name]: selectedOption.value
        }));
    
        if (name === "estabelecimento_id") {
            const estabelecimentoSelecionado = lojas.find((opt) => opt.id == selectedOption.value);
    
            if (estabelecimentoSelecionado) { 
                setUserData(prevData => ({
                    ...prevData,
                    razao: estabelecimentoSelecionado.razao,
                    cnpj: estabelecimentoSelecionado.cnpj,
                }));
            }
        }
    };
    

    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState('');

    const baseUrl = process.env.REACT_APP_API_URL;
    
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));

        if (name === "cep" && value.length === 9) {
            buscarEndereco(value);
        }
    };

    const buscarEndereco = async (cep) => {
        try {
          const response = await fetch(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
          const data = await response.json();
    
          if (!data.erro) {
            setUserData(prevData => ({
              ...prevData,
              endereco: data.logradouro,
              bairro: data.bairro,
              cidade: data.localidade,
              estado: data.uf
            }));
          } else {
            console.log("CEP não encontrado.");
          }
        } catch (error) {
          console.error("Erro ao buscar o CEP:", error);
        }
      };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setFormLoading(true);
        try {
            const response = await fetch(`${baseUrl}/participante/cadastro`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData)
            });
            if (response.ok) {

                const loginData = {
                    email: userData.email,
                    password: userData.password,
                    lembrar: false
                };

                const responseLogin = await fetch(`${baseUrl}/participante/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(loginData)
                });

                if (!responseLogin.ok) {
                    setFormLoading(false);
                    setError('Não foi possível efetuar o seu login.');
                    return;
                }

                const data = await responseLogin.json();

                localStorage.setItem('access_token', data.token);
                localStorage.setItem('user_id', data.usuario.id);
                localStorage.setItem('user_type', data.usuario.tipo);

                setFormLoading(false);
                
                window.location.href = '/premios/meus';
                setError('');

            } else {
                if (response.status === 422) {
                    const errors = await response.json();
                    console.log(response)
                    setFormLoading(false);
                    setUserErrorData(errors);
                    navigate('/participantes/cadastro', {
                        state: {
                            message: { type: 'error', text: 'Por favor, verifique o(s) campo(s) sinalizados em vermelho.', show: true},
                        },
                    });
    
                }
            }
        } catch (error) {
            setFormLoading(false);
            setError(error.message);
            console.log(error)
        }
    };

    const fetchStates = async () => {
        try {
            const response = await fetch(`${baseUrl}/estados`, {
                method: 'GET',
            });

            if (!response.ok) {
                setError('Erro ao buscar os destinos.');
                return;
            }

            const data = await response.json();

            setStates(data.estados.map(state => ({
                value: state.uf,
                label: `${state.nome} - ${state.uf}`, 
            })));

        } catch (error) {
            setError(error.message);
        } 
    };

    const fetchLojas = async () => {
        try {
            const response = await fetch(`${baseUrl}/lojas`, {
                method: 'GET',
            });

            if (!response.ok) {
               setError('Erro ao buscar as lojas.');
               return;
            }

            const data = await response.json();
            setLojas(data.lojas);
            setLojasSelect(data.lojas.map(loja => ({
                value: loja.id,
                label: `${loja.nome} - ${loja.cnpj}`, 
            })));

        } catch (error) {
            setError(error.message);
        } 
    };

    useEffect(() => {
        fetchStates();
        fetchLojas();
    }, []);
    
    const customStyles = {
        control: (provided, state) => ({
          ...provided,
          fontSize: '14px',
          borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
          boxShadow: state.isFocused ? '0 0 0 0px #70c75c' : 'none', 
          '&:hover': {
            borderColor: state.isFocused ? '#70c75c' : '#d1d5db', 
          },
        }),
      };

    return (
        <form onSubmit={handleSubmit} className="pb-24">
            <div className="relative">
                <div className="absolute w-screen left-1/2 -translate-x-1/2 h-[70%] bg-secondary -bottom-24" />
                <div className="relative bg-white rounded-xl p-6 md:10 w-full">
                    <div className="relative w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="estabelecimento_id" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Loja</label>
                            <Select
                                styles={customStyles}
                                name="estabelecimento_id"
                                options={lojasSelect}
                                value={lojasSelect.find(option => option.value == userData.estabelecimento_id) || null}
                                onClick={() => setUserErrorData(prevData => ({...prevData, estabelecimento_id: []}))}
                                onChange={selectedOption => handleSelectChange('estabelecimento_id', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.estabelecimento_id && userErrorData.estabelecimento_id[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.estabelecimento_id[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, estabelecimento_id: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                        <div className='w-full'>
                            <label htmlFor="Cnpj" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">CNPJ</label>
                            <InputMask
                                type="text"
                                name="cnpj"
                                mask="__.___.___/____-__"
                                replacement={{ _: /\d/ }}
                                value={userData.cnpj}
                                onClick={() => setUserErrorData(prevData => ({ ...prevData, cnpj: [] }))}
                                onChange={handleChange}
                                placeholder="CNPJ"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.cnpj && userErrorData.cnpj[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.cnpj[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, cnpj: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div> 
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="razao" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Razão social</label>
                            <input
                                value={userData.razao}
                                onClick={() => setUserErrorData(prevData => ({...prevData, razao: []}))}
                                onChange={handleChange}
                                type="text"
                                id="razao"
                                name="razao"
                                placeholder="Razão social"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.razao && userErrorData.razao[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.razao[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, razao: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className='w-full'>
                            <label htmlFor="cep" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">CEP</label>
                            <InputMask
                                type="text"
                                name="cep"
                                placeholder='CEP'
                                mask="_____-___."
                                replacement={{ _: /\d/ }}
                                value={userData.cep}
                                onClick={() => setUserErrorData(prevData => ({ ...prevData, cep: [] }))}
                                onChange={handleChange}
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.cep && userErrorData.cep[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.cep[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, cep: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    
                    </div> 
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="bairro" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Bairro</label>
                            <input
                                value={userData.bairro}
                                onClick={() => setUserErrorData(prevData => ({...prevData, bairro: []}))}
                                onChange={handleChange}
                                type="text"
                                id="bairro"
                                name="bairro"
                                placeholder="Bairro"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.bairro && userErrorData.bairro[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.bairro[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, bairro: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                        
                        <div className='w-full'>
                            <label htmlFor="cidade" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Cidade</label>
                            <input
                                value={userData.cidade}
                                onClick={() => setUserErrorData(prevData => ({...prevData, cidade: []}))}
                                onChange={handleChange}
                                type="text"
                                id="cidade"
                                name="cidade"
                                placeholder="Cidade"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.cidade && userErrorData.cidade[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.cidade[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, cidade: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="estado" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Estado</label>
                            <Select
                                styles={customStyles}
                                name="estado"
                                options={states}
                                value={states.find(option => option.value == userData.estado) || null}
                                onClick={() => setUserErrorData(prevData => ({...prevData, estado: []}))}
                                onChange={selectedOption => handleSelectChange('estado', selectedOption)}
                                placeholder="Selecione uma opção..."
                                className="user-select"
                            />
                            {userErrorData.estado && userErrorData.estado[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.estado[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, estado: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                        <div className='w-full'>
                            <label htmlFor="endereco" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Endereço</label>
                            <input
                                value={userData.endereco}
                                onClick={() => setUserErrorData(prevData => ({...prevData, endereco: []}))}
                                onChange={handleChange}
                                type="text"
                                id="endereco"
                                name="endereco"
                                placeholder="Endereço"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.endereco && userErrorData.endereco[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.endereco[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, endereco: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                    </div> 
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Nome</label>
                            <input
                                value={userData.nome}
                                onClick={() => setUserErrorData(prevData => ({...prevData, nome: []}))}
                                onChange={handleChange}
                                type="text"
                                id="nome"
                                name="nome"
                                placeholder="Nome"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.nome && userErrorData.nome[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.nome[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, nome: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className='w-full'>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">E-mail</label>
                            <input
                                value={userData.email}
                                onClick={() => setUserErrorData(prevData => ({...prevData, email: []}))}
                                onChange={handleChange}
                                type="email"
                                id="email"
                                name="email"
                                placeholder="E-mail"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.email && userErrorData.email[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.email[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, email: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                    </div>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="rg" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">RG</label>
                            <input
                                value={userData.rg}
                                onClick={() => setUserErrorData(prevData => ({...prevData, rg: []}))}
                                onChange={handleChange}
                                type="text"
                                id="rg"
                                name="rg"
                                placeholder="RG"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.rg && userErrorData.rg[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.rg[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, rg: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                        <div className='w-full'>
                            <label htmlFor="cpf" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">CPF</label>
                            <InputMask
                                mask="___.___.___-__"
                                value={userData.cpf}
                                replacement={{ _: /\d/ }}
                                onClick={() => setUserErrorData(prevData => ({...prevData, cpf: []}))}
                                onChange={handleChange}
                                type="text"
                                id="cpf"
                                name="cpf"
                                placeholder="CPF"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.cpf && userErrorData.cpf[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.cpf[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, cpf: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                    </div>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        
                        <div className='w-full'>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Senha</label>
                            <input
                                value={userData.password}
                                onClick={() => setUserErrorData(prevData => ({...prevData, password: []}))}
                                onChange={handleChange}
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Senha"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.password && userErrorData.password[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.password[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, password: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>   
                        <div className='w-full'>
                            <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Confirmar senha</label>
                            <input
                                value={userData.password_confirmation}
                                onClick={() => setUserErrorData(prevData => ({...prevData, password_confirmation: []}))}
                                onChange={handleChange}
                                type="password"
                                id="password_confirmation"
                                name="password_confirmation"
                                placeholder="Confirmar senha"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.password_confirmation && userErrorData.password_confirmation[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.password_confirmation[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, password_confirmation: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>    
                    </div>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
                        <div className='w-full'>
                            <label htmlFor="fone" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Telefone</label>
                            <InputMask
                                type="text"
                                name="fone"
                                placeholder='Telefone'
                                mask="(__) _____-____"
                                replacement={{ _: /\d/ }}
                                value={userData.fone}
                                onClick={() => setUserErrorData(prevData => ({...prevData, fone: []}))}
                                onChange={handleChange}
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.fone && userErrorData.fone[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.fone[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, fone: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div>
                        <div className='w-full'>
                            <label htmlFor="nascimento" className="block text-sm font-medium text-gray-700 mb-0.5 sm:mb-2">Data de nascimento</label>
                            <input
                                value={userData.nascimento}
                                onClick={() => setUserErrorData(prevData => ({...prevData, nascimento: []}))}
                                onChange={handleChange}
                                type="date"
                                id="nascimento"
                                name="nascimento"
                                placeholder="Data de nascimento"
                                className="border border-gray-300 text-sm p-2 rounded-md w-full outline-none focus:border-secondary focus-visible:shadow-none"
                            />
                            {userErrorData.nascimento && userErrorData.nascimento[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.nascimento[0]} <span onClick={() => setUserErrorData(prevData => ({...prevData, nascimento: []}))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                        </div> 
                    </div>

                    <button
                        className="block w-full max-w-60 mx-auto mt-12 mb-8 cursor-pointer rounded-lg border-2 border-tertiary bg-tertiary p-2 text-lg md:text-xl text-primary text-center font-semibold transition hover:border-primary hover:bg-primary hover:text-white"
                        type="submit"
                    >
                        {!formLoading ? (
                            'Cadastrar'
                        ) : (
                            <div role="status" className="flex justify-center items-center">
                                <svg aria-hidden="true" className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                        )}
                    </button>
                </div>
            </div>
        </form>
    );
}

export default FormRegister;